import { createSelector, Selector } from 'reselect';
import { selectProject } from '../project';
import { State } from '../../reducers';
import { CaseSpecificationWithIndexes } from '../../../domain/specification/cases/CaseSpecification';
import { getProjectCasesSpecifications } from '../../../domain/specification/project/queries/cases/getProjectCasesSpecifications';

export const selectAllCasesSpecifications: Selector<State, CaseSpecificationWithIndexes[]> =
  createSelector([selectProject], getProjectCasesSpecifications);
